export enum RevaluationStatus {
  RESERVED1,
  RevalOk,
  RevalError,
}

export namespace RevaluationStatus {
  let elements = [
    RevaluationStatus.RESERVED1,
    RevaluationStatus.RevalOk,
    RevaluationStatus.RevalError,
  ];
  let alias = "com.bcdfx.model.RevaluationStatus";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
